import { Directive, Input } from "@angular/core";

@Directive({
	// eslint-disable-next-line @angular-eslint/directive-selector
	selector: 'a[maybeExternal], a[cdxMaybeExternal]',
})
export class MockMaybeExternalLinkDirective {
	@Input() maybeExternalCurrentTab: boolean;
}